import { Directive, input } from '@angular/core';
import { classes } from '@lite-workspace/shared/helm-ui/utils';
import { type VariantProps, cva } from 'class-variance-authority';

const emptyVariants = cva(
  'flex w-full min-w-0 flex-1 flex-col items-center justify-center gap-4 rounded-[var(--r-l)] border-dashed text-center text-balance',
  {
    variants: {
      padding: { md: 'p-12', none: 'p-0' },
    },
    defaultVariants: { padding: 'md' },
  },
);

export type EmptyPadding = NonNullable<VariantProps<typeof emptyVariants>['padding']>;

@Directive({
  selector: '[hlmEmpty],hlm-empty',
  host: { 'data-slot': 'empty' },
})
export class HlmEmpty {
  public readonly padding = input<EmptyPadding>('md');

  constructor() {
    classes(() => emptyVariants({ padding: this.padding() }));
  }
}
